






import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject} from "@/support/reactive"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsNavigatorBadge extends Vue {
    @Prop() counter!: number;
    @Prop({type: Boolean}) active!: boolean;

    @ActiveInject({from: 'jds.navigator.item.active', default: false}) activeItem!: boolean;

    get classes() {
        if (!this.active) {
            return ['jds-bg-grey-700', 'jds-text-white'];
        }
        return ['jds-bg-blue-500', 'jds-text-white'];
    }
}
